<template>
<div class="d-flex justify-content-center mt-4 mb-2 button-bar">
  <SidebarButton v-for="(button, index) in buttons" :key="index" :id="index" :borderColor="button.borderColor" :fillColor="button.fillColor" :color="button.color" :caption="button.caption" :active="button.active" @clicked="buttonClicked"/>
</div>
</template>

<script>
import SidebarButton from '@/components/SidebarButton'
export default {
  components: {
    SidebarButton
  },
  data: () => ({
  }),
  props: {
    buttons: Array
  },
  created () {
  },
  mounted () {
    this.btns = this.buttons
  },
  methods: {
    buttonClicked: function (id, active) {
      if (id.length === 0) {
        return
      }
      id = parseInt(id)
      this.$emit('buttonActive', id, active)
    }
  }
}
</script>

<style>
.button-bar div {
  line-height: 1.8rem;
  border: 1px solid gray;
  border-radius: 5px;
  width: calc(100% / 8.5);
  font-weight: bold;
  /* display: -webkit-inline-box; */
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: smaller;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarButtons.vue